import React, { PropsWithChildren, useEffect, useRef } from 'react';
import { Toast } from 'primereact/toast';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

interface ToastContextType {
  showToastMessage: (summary: string, detail: any, severity: string, life?: number) => void;
  redirectWithToastMessage: (url: string, summary: string, detail: string, severity: string) => void;
}

export const ToastContext = React.createContext<ToastContextType>({
  showToastMessage: () => {},
  redirectWithToastMessage: () => {},
});

export const ToastProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const toast = useRef<Toast>(null);
  const router = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const runAs = searchParams.get('runAs');


  const showToastMessage = (summary: string, detail: string, severity: string, life = 5000) => {
    if (toast && toast.current) {
      //@ts-ignore
      toast.current.show({ severity, summary, detail, closable: true, life, stacked: true });
    }
  };

  useEffect(() => {
    const { toastMessage } = router; //.query['summary'] as string;

    if (toastMessage) {
      const summary = router['summary'] as string;
      const detail = router['detail'] as string;
      const severity = router['severity'] as string;

      if (toast && toast.current) {
        //@ts-ignore
        toast.current.show({ severity, summary, detail });
      }
    }
  }, [router['summary']]);

  const redirectWithToastMessage = (url: string, summary: string, detail: string, severity: string) => {
    navigate(appendQueryParams(url, summary, detail, severity));
  };

  const appendQueryParams = (url: string, summary: string, detail: string, severity: string): string => {
    const params = new URLSearchParams({ summary, detail, severity });

    if (runAs !== undefined && runAs !== null && String(runAs).length > 0) {
      params.set('runAs', String(runAs));
    }

    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}${params.toString()}`;
  };

  return (
    <ToastContext.Provider value={{ showToastMessage, redirectWithToastMessage }}>
      {children}
      <Toast ref={toast} style={{ zIndex: 40000 }} />
    </ToastContext.Provider>
  );
};
